export default __webpack_public_path__ + "static/media/semcasting-tradedesk-third-party-logo.3dbe18e3.svg";